import { useEffect } from 'react';
import { MEDIA_EXPORT_FINISHED } from 'modules/Media/export/events';

/**
 * Refetch the notification list when a media zip export finishes.
 *
 * The archive is delivered as a notification, but every header fetches that list once on mount only — so
 * an export that completes while the user stays put leaves the bell on a stale count until they reload or
 * navigate. useMediaExportProgress announces the moment one lands; this turns it into a refetch.
 *
 * Lives in a hook because there are three bells (the new-UI TopBar, its MobileChrome counterpart, and the
 * legacy Header) and only one of them is mounted at a time — whichever it is has to react.
 *
 * @param {function} loadNotifications the header's own fetcher (already wrapped in useCallback there)
 * @param {boolean} enabled normally `isAuthenticated`; nothing to refetch when signed out
 */
const useRefreshNotificationsOnMediaExport = (loadNotifications, enabled) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const refresh = () => loadNotifications();
    window.addEventListener(MEDIA_EXPORT_FINISHED, refresh);
    return () => window.removeEventListener(MEDIA_EXPORT_FINISHED, refresh);
  }, [enabled, loadNotifications]);
};

export default useRefreshNotificationsOnMediaExport;
